import Vue from 'vue'
import VueDateFns from "vue-date-fns";
import localeFi from "date-fns/locale/fi";

Vue.use(VueDateFns, 'D.M.YYYY', { localeFi });